import { Box } from '@mantine/core';
import { forwardRef, useState } from 'react';
import { useReducedMotion } from '../hooks';

export interface PressScaleProps {
  children: React.ReactNode;
  scale?: number;
  duration?: number;
  onClick?: () => void;
}

const PressScale = forwardRef<HTMLDivElement, PressScaleProps>(
  (
    {
      children,
      scale = 0.95,
      duration = 100,
      onClick,
    },
    ref
  ) => {
    const reducedMotion = useReducedMotion();
    const [isPressed, setIsPressed] = useState(false);

    return (
      <Box
        ref={ref}
        onMouseDown={() => setIsPressed(true)}
        onMouseUp={() => setIsPressed(false)}
        onMouseLeave={() => setIsPressed(false)}
        onTouchStart={() => setIsPressed(true)}
        onTouchEnd={() => setIsPressed(false)}
        onClick={onClick}
        style={{
          transform: isPressed && !reducedMotion ? `scale(${scale})` : 'scale(1)',
          transition: reducedMotion ? 'none' : `transform ${duration}ms ease-out`,
          cursor: onClick ? 'pointer' : 'default',
          userSelect: 'none',
        }}
      >
        {children}
      </Box>
    );
  }
);

PressScale.displayName = 'PressScale';

export default PressScale;
